import { isEmpty, remove, findIndex } from 'lodash';
import { Actividad, Tarea } from '@app/shared';
import { StorageService } from './';

/**
 * Funcionalidad en común usada para apoyar a los
 * administradores de tarea y actividad.
 *
 * @export
 * @abstract
 * @class Common
 */
export abstract class CommonManage {
  protected ss: StorageService;

  /**
   * Setea la key 'orden' de las actividades o tareas
   * utilizando el indice de los elementos del array.
   * El orden comienza en 1 por ende se le suma +1 al
   * indice.
   *
   * @param {any[]} items
   * @memberof CommonManage
   */
  reorderWithIndex(items: any[]): any[] {
    return items.map((item, i) => {
      item.orden = i + 1;
      return item;
    });
  }

  /**
   * Elimina un objeto de un array, filtrando dicho
   * objecto a través de la propiedad 'id'.
   *
   * @protected
   * @param {any[]} souce
   * @param {number} id
   * @returns {boolean}
   * @memberof CommonManage
   */
  protected removeObject(souce: any[], id: number): boolean {
    const removed = remove(souce, { id: id as any });
    if (!isEmpty(removed)) {
      return true;
    }
    return false;
  }

  /**
   * Determina el valor de la key 'orden' del ultimo objeto.
   *
   * @protected
   * @param {(Actividad[] | Tarea[])} items
   * @returns {number}
   * @memberof CommonManage
   */
  protected getCurrentOrder(items: Actividad[] | Tarea[]): number {
    const last = items[items.length - 1];
    return last ? last.orden : 0;
  }

  /**
   * Retorna el siguiente orden para una actividad o tarea nueva.
   *
   * @protected
   * @param {('activity' | 'task')} resource
   * @returns {number}
   * @memberof CommonManage
   */
  protected getNextOrder(items: Actividad[] | Tarea[]): number {
    const currentOrder = this.getCurrentOrder(items);
    return currentOrder ? currentOrder + 1 : 1;
  }

  /**
   * Aumenta +1 al la key 'orden' de los objetos
   * que empiecen desde un orden específico.
   *
   * @protected
   * @param {any[]} items
   * @param {number} from
   * @returns {(any[] | null)}
   * @memberof CommonManage
   */
  protected updateOrder(items: any[], from: number): any[] | null {
    const start = findIndex(items, ['orden', from]);
    if (start !== -1) {
      const toOrder = items.slice(start);
      toOrder.map(item => {
        from++;
        item.orden = from;
      });
      return [...items.slice(0, start), ...toOrder];
    }
    return null;
  }

/**
 * Al modificar el orden de un elemento tambien se produce un cambio en los
 * demás elementos, por ende esté método se encarga de agregar al historial de
 * modificaciones los elementos afectados que ya estan sincronizados con la DB.
 *
 * Nota: cuando se habla de elemento se hace referencia a una actividad o
 * tarea según corresponda el caso.
 *
 * @protected
 * @param {('activities' | 'tasks')} type
 * @param {(Actividad[] | Tarea[])} items
 * @memberof CommonManage
 */
protected registerOrderUpdateInHistory(type: 'activities' | 'tasks', items: Actividad[] | Tarea[]) {
    const isLocalElement = (el: Actividad | Tarea): boolean => {
      if (el.id < 0) {
        return true;
      }
      return false;
    };
    const registerInHistory = (el: Actividad | Tarea) => {
      this.ss.registerActionInHistory(type, 'update', {
        activityId: type === 'activities' ? el.id : (<Tarea>el).meta.idActivity,
        taskId: type === 'tasks' ? el.id : null,
      }, el.id);
    };
    (<any[]>items).map(item => {
      if (!isLocalElement(item)) {
        registerInHistory(item);
      }
    });
  }

} // End class



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/shared/common-manage.ts